import React from 'react'
import { NavLink } from 'react-router-dom'


const ReturnButton = props => {
    return (
        <NavLink to='/acervo'><button className='button btn-return is-fullWidth'>Regresar</button></NavLink>
    )
}

export default ReturnButton


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Buttons/ReturnButton.js